import { CCol, CContainer, CRow } from "@coreui/react";
import ServicePojo from "../../services/BusinessType/Service/ServicePojo/ServicePojo";
import SingleService from "./SingleService";
import { Language } from "../../language/English";
import { useEffect, useState } from "react";
import Service from "./Service";
import ServiceActivateModal from "./ServiceActivateModal";
import ServiceService from "../../services/BusinessType/Service/ServiceService";
import { SERVICE_ACTIVE_STATUS } from "../../services/BusinessType/Service/ServiceConstant";
import { toast } from "react-toastify";

const ServiceList = (props: { services: ServicePojo[]; setShowLoader: Function, editService: Function, manageServiceForState: Function }) => {
    const [searchedService, setSearchedService] = useState<string>("");

    const filteredServices = props.services.filter((service: ServicePojo) =>
        service.name
            ?.toLowerCase()
            .includes(searchedService.trim().toLowerCase())
    );

    const [ activateService, setActivateService ] = useState<ServicePojo | null>(null);
    const [ showActivateModal, setShowActivateModal ] = useState<boolean>(false);

    useEffect(() => {
        if (activateService !== null) {
            setShowActivateModal(true);
        }
    }, [activateService]);

    useEffect(() => {
        if (showActivateModal === false) {
            setActivateService(null);
        }
    }, [showActivateModal]);
    const confirmActivate = async() => {
        if(activateService !== null){
            setShowActivateModal(false);
            props.setShowLoader(true);
            const serviceService = new ServiceService();
            const response = await serviceService.activateService(activateService.serviceId);
            if(response.isSuccess){
                activateService.status = SERVICE_ACTIVE_STATUS;
                props.manageServiceForState(activateService);
                toast.success(Language.SERVICE_ACTIVATED_SUCCESSFULLY);
            }  else {
                toast.error(Language.SOMETHING_WENT_WRONG);
            }
            setActivateService(null);
            props.setShowLoader(false);
        } 
    }

    return (
        <CContainer className="mt-4">
            <CRow>
                <CCol md={12}>
                    <h3>{Language.SERVICES}</h3>
                </CCol>

                <CCol md={3}>
                    <hr className="custom_hr" />
                </CCol>
                <CCol md={9}></CCol>
                {
                    showActivateModal && (
                        <ServiceActivateModal  showActivateModal={showActivateModal} setShowActivateModal={setShowActivateModal} confirmActivate={confirmActivate}/>
                    )
                }

                {props.services.length !== 0 && (
                    <>
                        <CCol md={6}>
                            <label htmlFor="searchService" className="card-title">
                                {Language.SEARCH_SERVICE}
                            </label>
                            <input
                                type="text"
                                id="searchService"
                                className="form-control mt-2"
                                placeholder={Language.JUST_TYPE_HERE}
                                value={searchedService}
                                onChange={(e) => setSearchedService(e.target.value)}
                            />
                        </CCol>
                        <CCol md={6}></CCol>
                    </>
                )}

                <CCol md={12}>
                    <hr />
                </CCol>

                <CCol md={12}>
                    {filteredServices.length > 0 ? (
                        filteredServices.map((service: ServicePojo) => (
                            <SingleService
                                key={service.serviceId}
                                service={service}
                                editService={props.editService}
                                setActivateService={setActivateService}
                            />
                        ))
                    ) : (
                        <p className="text-muted">
                            {Language.NO_SERVICE_FOUND ?? "No services found"}
                        </p>
                    )}
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default ServiceList;
